import React, { useMemo } from 'react';
import { CellTypes, Column } from '~/Components/DataTable/DataTable.types';
import { NORMAL_GREY } from '~/Constants/Colors.constants';
import { FONT_SIZE_MEDIUM } from '~/Constants/UI.constants';
import { useLanguage } from '~/Hooks';
import { ProfilePictureCard } from '~/UIKit';

type IStaffColumnNameType = 'image' | 'email' | 'role';

export const useStaffListColumns = () => {
  const { t } = useLanguage();

  const columnMap: {
    [key in IStaffColumnNameType]: Column;
  } = useMemo(
    () => ({
      image: {
        label: t('form.field.name'),
        propertyIds: ['imageUrl', 'firstName', 'lastName', 'isOwner'],
        cellType: CellTypes.String,
        formatter: (staff: {
          imageUrl: string;
          firstName: string;
          lastName: string;
          isOwner: boolean;
        }) => (
          <ProfilePictureCard
            displayName={`${staff.firstName} ${staff.lastName} ${
              staff.isOwner ? `(${t('manager.owner')})` : ''
            }`}
            imageUrl={staff.imageUrl}
            bgColor={NORMAL_GREY}
            fontSize={FONT_SIZE_MEDIUM}
          />
        ),
      },
      email: {
        label: t('app.email'),
        propertyIds: 'email',
        cellType: CellTypes.String,
        formatter: (value: string) => value,
      },
      role: {
        label: t('app.accessType'),
        propertyIds: 'accessType',
        cellType: CellTypes.String,
        formatter: (value: string) => t(`settings.staff.accessType.${value}`),
      },
    }),
    [t],
  );

  return {
    columnMap,
  };
};
